import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import RtoTabDetails from "./RtoTabDetails";
import RtoRecommendations from "./RtoRecommendations";

const RtoReportTab = ({ reportData: parentReportData }) => {
  const { t } = useTranslation("reports_recs", { keyPrefix: "reports_common" });
  const [selectedSubTab, setSelectedSubTab] = useState("summary");

  // Sub-tab categories
  const subTabs = [
    { id: "summary", label: t("responseTimeOptimizationSummary"), color: "#3b82f6" },
    { id: "recommendations", label: t("responseTimeOptimizationRecommendations"), color: "#3b82f6" }
  ];

  const getSubTabButtonStyle = (tab) => {
    const isSelected = selectedSubTab === tab.id;
    return {
      padding: "12px 20px",
      background: isSelected
        ? "linear-gradient(135deg, #3b82f6, #1d4ed8)"
        : "var(--card-bg)",
      color: isSelected ? "white" : "var(--body-text)",
      border: isSelected
        ? "2px solid #3b82f6"
        : "2px solid var(--card-border)",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "500",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      boxShadow: isSelected
        ? "0 4px 12px rgba(59, 130, 246, 0.3)"
        : "0 2px 4px rgba(0, 0, 0, 0.1)",
      minWidth: "150px",
      justifyContent: "center"
    };
  };

  // Extract rto_results from score_json (where it's actually stored)
  const scoreJson = parentReportData?.score_json || {};
  const rtoData = scoreJson?.rto_results;

  // Check if key exists in score_json
  const keyExists = scoreJson && typeof scoreJson === 'object' && 'rto_results' in scoreJson;

  // Check if rtoData is empty object (no keys or all falsy)
  const isEmptyObject = !rtoData ||
    (typeof rtoData === 'object' &&
      !Array.isArray(rtoData) &&
      Object.keys(rtoData).length === 0);

  // Check if rtoData is a valid object (no strict structure validation)
  const hasExpectedStructure = rtoData &&
    typeof rtoData === 'object' &&
    !Array.isArray(rtoData);

  return (
    <div style={{ padding: "20px" }}>
      {/* Sub-tab Button Selectors */}
      <div style={{ marginBottom: "24px", marginTop: "10px" }}>
        <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px"
        }}>
          {subTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setSelectedSubTab(tab.id)}
              style={getSubTabButtonStyle(tab)}
            >
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      {selectedSubTab === "summary" && (
        <RtoTabDetails 
          rtoData={rtoData}
          keyExists={keyExists}
          isEmptyObject={isEmptyObject}
          hasExpectedStructure={hasExpectedStructure}
        />
      )}
      {selectedSubTab === "recommendations" && (
        <RtoRecommendations 
          reportData={parentReportData}
        />
      )}
    </div>
  );
};

export default RtoReportTab;
